import styled from "styled-components"
import {Col} from "@irati/ui/src/Layout"

export const StyledCol = styled(Col)`
  padding-left: 0px;
  padding-right: 0px;
  margin-bottom: 16px;
`
